import { createAuth0 } from '@auth0/auth0-vue';

export default createAuth0(
  {
    domain: process.env.AUTH0_DOMAIN,
    clientId: process.env.AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri: process.env.AUTH0_REDIRECT_URL,
    },
  },
  {
    skipRedirectCallback: true,
  },
);
